import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { LoadingScreenService } from "src/app/services/loading-screen/loading-screen.service";
import { FlashController } from "../../flash-payment-core/services/flash-controller.service";

@Component({
  selector: "app-dialog-confirm",
  templateUrl: "./dialog-confirm.component.html",
  styleUrls: ["./dialog-confirm.component.sass"],
})
export class DialogConfirmComponent implements OnInit {
  message = '';
  constructor(
    private flashController: FlashController,
    private loadingScreenService: LoadingScreenService,
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
   this.message = this.data.message;
  }

  continue() {
    if (this.data.type === 1) {
      this.loadingScreenService.startLoading();
      this.flashController.initData();
      this.close();
      setTimeout(() => {
        this.loadingScreenService.stopLoading();
      }, 1500);
    } else if (this.data.type === 2) {
     this.flashController.startDeleteAction(this.data.card);
     this.close();
    }


  }

  close() {
    this.dialogRef.close();
  }
}


